// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nn-0";
export var discountCodeInput = "_nn-1";